import React from "react";

/**
 * A failed lazy adapter import (ModelSpace/GeoSpace) must show a usable
 * retry/error state, not an empty stage. Mirrors
 * core/workspace/2d/AdapterLoadBoundary.jsx's identical pattern (itself
 * mirroring spaces/SpaceHost.jsx's SpaceErrorBoundary) - a small, deliberate
 * duplicate rather than a cross-import between the 2D and 3D workspace
 * folders, since the two are otherwise independent engines.
 */
export default class AdapterLoadBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(`[Universal3DWorkspace] ${this.props.label || "adapter"} failed to load:`, error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="u3d-state u3d-state-failed" role="alert" aria-live="assertive">
          <strong>{this.props.label || "This surface"} could not be opened</strong>
          <p>Your work is unchanged. You can try again.</p>
          <button type="button" onClick={() => this.props.onRetry ? this.props.onRetry() : this.setState({ error: null })}>Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
